@if (item.children) {
    <div
        appCollapse
        [shouldBeExpanded]="isLinkActive"
        [filterGroupId]="item.filterGroupId"
        class="list-group {{ item.class }}">
        <div style="position: relative">
            <span class="collapse-header">
                <span class="add-arrow"></span>
            </span>

            @if (item.isItemWithoutLink) {
                <div
                    class="list-group-item list-item-header d-flex flex-row justify-content-between align-items-center">
                    <span>
                        @if (item.icon) {
                            <sb-inline-svg
                                class="icon vertical-align-middle"
                                aria-label="My icon"
                                [url]="item.icon"></sb-inline-svg>
                        }
                        <span
                            class="vertical-align-middle group-item-title truncate"
                            [class.group-item-title_no-icon]="!item.icon"
                            translate>
                            {{ item.title }}
                        </span>
                    </span>
                    <span>
                        @if (item.withEditButton) {
                            <button
                                class="btn btn-icon btn-transparent"
                                (click)="item.editButtonClickHandler()"
                                [tooltip]="item.editButtonTooltipText"
                                container="body">
                                <sb-inline-svg
                                    class="icon"
                                    aria-label="My icon"
                                    [url]="
                                        '/sb-tools/theme/images/Svg icons WEB/Web icons/Pen icon.svg'
                                    "></sb-inline-svg>
                            </button>
                        }
                        @if (count) {
                            <span class="badge">{{ count }}</span>
                        }
                    </span>
                </div>
            } @else {
                <a
                    class="left-menu-link"
                    [routerLink]="['/', communityName, 'tickets']"
                    [queryParams]="item.queryParams"
                    [ngClass]="{ active: isLinkActive }">
                    <div
                        (click)="checkLinkClick($event)"
                        class="link-content-wrapper list-group-item list-group-item-action d-flex justify-content-between align-items-center">
                        <span>
                            @if (item.icon) {
                                <sb-inline-svg
                                    class="icon vertical-align-middle"
                                    aria-label="My icon"
                                    [url]="item.icon"></sb-inline-svg>
                            }
                            <span class="vertical-align-middle truncate" translate>{{ item.title }}</span>
                        </span>
                        @if (count) {
                            <span class="badge">{{ count }}</span>
                        }
                    </div>
                </a>
            }
        </div>
        <div class="channels collapse-body">
            @for (subItem of item.children; track subItem) {
                <app-left-menu-item [item]="subItem" [countUpdateMarker]="countUpdateMarker"></app-left-menu-item>
            }
        </div>
    </div>
} @else {
    <div class="{{ item.class }}">
        <a
            class="left-menu-link"
            [routerLink]="['/', communityName, 'tickets']"
            [queryParams]="item.queryParams"
            [ngClass]="{ active: isLinkActive }"
            placement="bottom"
            container="body"
            [tooltip]="item.filterDescription ? tooltipContent : ''"
            [adaptivePosition]="false"
            triggers=""
            #leftMenuLinkTooltip="bs-tooltip"
            containerClass="customClass"
            (mouseenter)="showTooltip()"
            (mouseleave)="hideTooltip()">
            <ng-template #tooltipContent>
                <div [innerHtml]="item.filterDescription | safeHtml"></div>
            </ng-template>
            <div
                (click)="checkLinkClick($event)"
                class="link-content-wrapper list-group-item list-group-item-action d-flex justify-content-between align-items-center">
                <span>
                    <!--                    todo: check this component for duplicated code-->
                    @if (item.icon) {
                        <sb-inline-svg
                            class="icon vertical-align-middle"
                            aria-label="My icon"
                            [url]="item.icon"></sb-inline-svg>
                    }
                    <span class="vertical-align-middle truncate" translate>{{ item.title }}</span>
                </span>

                <span>
                    @if (unhandledRepliesCount) {
                        <span class="badge badge-unhandled me-1">{{ unhandledRepliesCount }}</span>
                    }

                    @if (count) {
                        <span class="badge">{{ count }}</span>
                    }
                </span>
            </div>
        </a>
    </div>
}
